import { useId, useMemo } from "react";
import { NodeRenderer } from "./NodeRenderer";
import type { Document } from "@op/richtext-types";
import { isEmpty } from "./utils";

export interface RichTextRendererProps {
  content: Document;
}

export const RichTextRenderer = ({ content }: RichTextRendererProps) => {
  const id = useId();
  const empty = useMemo(() => isEmpty(content), [content]);

  if (empty) return null;
  return (
    <div id={`rich-text-${id}`} className="w-full flex flex-col gap-3">
      {content.content.map((node, idx) => (
        <NodeRenderer key={`rich-text-${id}-${idx}`} node={node} />
      ))}
    </div>
  );
};
